import config from '../config'
import { getWebchatSlotValue, isUsableWebchatSlotValue } from './slot'

/**
 * Normalize the runtime user identification payload against the current webchat slots.
 * @param {Object|null} userIdentification
 * @param {Object[]} webchatSlots
 * @returns {Object}
 */
export function getUserIdentificationState(userIdentification, webchatSlots) {
  const slotSlug = userIdentification && userIdentification.slotSlug ? userIdentification.slotSlug : null

  return {
    ...config.USER_IDENTIFICATION.DEFAULT_STATE,
    ...(userIdentification || {}),
    isResolved:
      !!(userIdentification && userIdentification.isEnabled) &&
      isUsableWebchatSlotValue(getWebchatSlotValue(webchatSlots, slotSlug))
  }
}

export default {
  getUserIdentificationState
}
